module.exports = __webpack_public_path__ + "static/media/nocontact.24d29ab5.svg";